// extracted by mini-css-extract-plugin
export default {"Header":"shonqUwZ","profile":"j_XD_0bO","userImgBox":"J5fI_1OD","userImg":"ICV19LpM","userInfo":"RZkzaIDd","userName":"pYIPsB9T","userLevel":"lDRN7qtg","userData":"UN9jptRL","headerContent":"_1A26oqw","servicesWrapper":"LTIKFiga","buttonsWrapper":"Oc_dcAaX","restartGameLink":"qymCLD0e"};
    if(module.hot) {
      // 1712151478421
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  